import { Component, OnInit } from '@angular/core';
import { UilabMatDialogRef } from '@uilab/ng-mat-components';

@Component({
    selector: 'app-cantdownload',
    templateUrl: './cantdownload.component.html',
    styleUrls: ['./cantdownload.component.scss'],
    standalone: false,
})
export class CantdownloadComponent implements OnInit {
    constructor(public dialogRef: UilabMatDialogRef<CantdownloadComponent>) {}

    ngOnInit(): void {}

    close(): void {
        this.dialogRef.close();
    }
}
